import {Injectable, inject} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {IKtCogsDetail, IKtServiceDetail, IKtTravelerPaymentDetail, IKtTripListItem} from '../interfaces/kt-trip.interface';

@Injectable({providedIn: 'root'})
export class KtTripService {
  private readonly http = inject(HttpClient);

  getTripById(id: number): Observable<IKtTripListItem> {
    return this.http.get<IKtTripListItem>(`tmt/sales-orders/kt-trips/${id}`);
  }

  getServiceById(id: number): Observable<IKtServiceDetail> {
    return this.http.get<IKtServiceDetail>(`tmt/sales-orders/kt-services/${id}`);
  }

  getTravelerPaymentById(id: number): Observable<IKtTravelerPaymentDetail> {
    return this.http.get<IKtTravelerPaymentDetail>(`tmt/sales-orders/kt-traveler-payments/${id}`);
  }

  getCogsById(id: number): Observable<IKtCogsDetail> {
    return this.http.get<IKtCogsDetail>(`tmt/sales-orders/kt-cogs/${id}`);
  }
}
